export var GooglePayEventListenerEnumsObj = {
    PAYAIR_GOOGLE_PAY_SDK_LISTENER: "PAYAIR_GOOGLE_PAY_SDK_LISTENER",
};
